import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import Works from "@/pages/works/page";
import WorkDetail from "@/pages/works/detail/page";
import News from "@/pages/news/page";
import NewsDetail from "@/pages/news/detail/page";
import Profile from "@/pages/profile/page";
import About from "@/pages/about/page";
import Search from "@/pages/search/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/works",
    element: <Works />,
  },
  {
    path: "/works/detail/:id",
    element: <WorkDetail />,
  },
  {
    path: "/news",
    element: <News />,
  },
  {
    path: "/news/detail/:id",
    element: <NewsDetail />,
  },
  {
    path: "/profile",
    element: <Profile />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/search",
    element: <Search />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;